import React, { useCallback, useState, useEffect } from 'react';
import classNames from 'classnames';
import { Clickable } from '@moda/om';
import './MobileSiteNavTabs.scss';

interface Props {
  tabs: string[];
  selected: string;
  onSelect?(tab: string): void;
}

export const MobileSiteNavTabs: React.FC<Props> = ({ tabs, onSelect, selected }) => {
  const [activeTab, setTab] = useState(selected);

  const handleClick = useCallback((tab: string) => {
    return () => setTab(tab);
  }, []);

  useEffect(() => onSelect && onSelect(activeTab), [activeTab, onSelect]);
  useEffect(() => setTab(selected), [selected]);

  return (
    <div className="MobileSiteNavTabs">
      <nav className="MobileSiteNavTabs__tabs">
        {tabs.map(tab => (
          <Clickable
            key={tab}
            className={classNames('MobileSiteNavTabs__tab', {
              'MobileSiteNavTabs__tab--active': activeTab === tab
            })}
            onClick={handleClick(tab)}
          >
            {tab}
          </Clickable>
        ))}
      </nav>
    </div>
  );
};
